// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 860 ? "menu" : chunkId) + "." + {"61":"1c95565e","372":"87d887d2","826":"727babc8","860":"f088d691"}[chunkId] + ".css";
};